import Item from '../api/item';

class AdditionalInfo {
  constructor(options) {
    const defaults = {
      additionalInfoInput: '#additional_information',
    };
    Object.assign(this, defaults, options);
  }

  init() {
    this._additionalInfoInput = document.querySelector(this.additionalInfoInput);
    if(this._additionalInfoInput) {
      this._additionalInfoInput.addEventListener('change', this._updateAdditionalInfo.bind(this));
    }

    this._item = new Item(window.ITEM_ID);
  }

  /**
   * Updates the item's damage_description field
   */
  _updateAdditionalInfo() {
    this._item.patch({ 'additional_information': this._additionalInfoInput.value }, false).then(res => {
      if(res.status === 'OK') {
        // great success!
      } else {
        // should we display a warning banner?
      }
    })
  }
}


module.exports = AdditionalInfo;
